export class Scroll {
	// ScrollPageTo script from https://gist.github.com/felipenmoura/650e7e1292c1e7638bcf6c9f9aeb9dd5
	// Used for very smooth Scroll To Anchor

	/**
	 * Will gracefuly scroll the page
	 * This function will scroll the page using
	 * an `ease-in-ou` effect.
	 *
	 * You can use it to scroll to a given element, as well.
	 * To do so, pass the element instead of a number as the position.
	 * Optionally, you can pass a `queryString` for an element selector.
	 *
	 * The default duration is half a second (500ms)
	 *
	 * This function returns a Promise that resolves as soon
	 * as it has finished scrolling. If a selector is passed and
	 * the element is not present in the page, it will reject.
	 *
	 * EXAMPLES:
	 *
	 * ```js
	 * window.scrollPageTo('#some-section', 2000);
	 * window.scrollPageTo(document.getElementById('some-section'), 1000);
	 * window.scrollPageTo(500); // will scroll to 500px in 500ms
	 * ```
	 *
	 * @returns {Promise}
	 * @param {HTMLElement|Number|Selector} Target
	 * @param {Number} Duration [default=500]
	 *
	 * Inspired by @andjosh's work
	 *
	 */
	static scrollPageTo(to, duration = 500, headerHeight) {
		//t = current time
		//b = start value
		//c = change in value
		//d = duration
		const easeInOutQuad = function (t, b, c, d) {
			t /= d / 2;
			if (t < 1) return c / 2 * t * t + b;
			t--;
			return -c / 2 * (t * (t - 2) - 1) + b;
		};

		return new Promise((resolve, reject) => {
			const element = (document.scrollingElement || document.documentElement || document.body);
			if (typeof to === 'string') {
				to = document.querySelector(to) || reject();
			}
			if (typeof to !== 'number') {
				// Removed the headerHeight from the ElementTop position because the headerHeight is fixed.
				// to = to.getBoundingClientRect().top + element.scrollTop;
				to = to.getBoundingClientRect().top + element.scrollTop - headerHeight + 1;
			}

			let start = element.scrollTop,
				change = to - start,
				currentTime = 0,
				increment = 20;

			const animateScroll = function () {
				currentTime += increment;
				let val = easeInOutQuad(currentTime, start, change, duration);
				element.scrollTop = val;
				if (currentTime < duration) {
					setTimeout(animateScroll, increment);
				} else {
					resolve();
				}
			};
			animateScroll();
		});
	}

	// Got the script from https://gist.github.com/hvgeertruy/0f760fc7aa304ca5bc51
	// Used to scroll the Tabsmenu bar on mobile

	//Custom scroll animator w/ easing support & requestAnimationFrame, who needs jQuery ^ ^
	//Supports window (use 'window') and element (use document.querySelector(...)[0]) scrolling
	//Want features? Use jQuery.

	//properties:
	// - Element: [required] The element you want the scroll to apply to. Use 'window' for window
	// - To: [required] the offset (in px) to scroll to. Note that it will add this to the current position
	// - Duration: [required] the duration (in ms) for the scrolling animation
	// - Direction: [optional] (default: 'horizontal') The direction for the scrolling animation (horizontal | vertical)

	static scrollTo(element, to, duration, direction) {
		let animating = false;

		if (animating || !element || to === undefined || !duration) { //stop when already triggered or missing args
			return false;
		}
		var _requestAnimationFrame = function (win, t) {
				return win[`webkitR${t}`] || win[`r${t}`] || win[`mozR${t}`] || win[`msR${t}`] || function (fn) {
					setTimeout(fn, 10);
				};
			}(window, 'requestAnimationFrame'),
			easeInOutCubic = function (t) {
				return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
			}, //Or get your own: http://gizma.com/easing/
			end = +new Date() + duration,
			from = (element === 'window') ? window.pageXOffset : element.scrollLeft;
		animating = true;

		if (direction === 'vertical') {
			from = (element === 'window') ? window.pageYOffset : element.scrollTop;
		}

		var step = function () {
			var current = +new Date(),
				remaining = end - current;

			if (remaining < 0) {
				animating = false;
			} else {
				var ease = easeInOutCubic(1 - remaining / duration);

				if (!direction || direction === 'horizontal') {
					(element === 'window') ? window.scrollTo(from + (ease * (to - from)), window.pageYOffset) : element.scrollLeft = from + (ease * (to - from));
				} else if (direction === 'vertical') {
					(element === 'window') ? window.scrollTo(window.pageXOffset, from + (ease * (to - from))) : element.scrollTop = from + (ease * (to - from));
				}
			}

			_requestAnimationFrame(step);
		};
		step();
	}

	/**
	 * Checks the scrollDirection
	 * @param lastScrollTop
	 * @returns {{scrollTop: *, direction: *}}
	 */
	static checkScrollDirection(lastScrollTop){
		const st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
		let direction = 'down';
		if (st > lastScrollTop){
			direction = 'down';
		} else {
			direction = 'up';
		}
		const scrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
		return { direction, scrollTop };
	}
}
